import React from 'react';
import { Header } from 'components/header/header';
import Iban from 'components/newAccountSteps/profileSteps/iban';
import ibanActions from 'actions/ibanActions';
import logActions from 'actions/logActions';
import stepsActions from 'actions/stepsActions';
import { CREDIT_CARD } from 'constants/userProfile';
import { VIDEOSELFIE_CAPTURE } from 'constants/featureFlagging';
import { StepsContent } from 'components/steps/stepsContent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import withFeatureToggling from '../../hocs/withFeatureToggling/withFeatureToggling';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import { withRouter } from 'react-router-dom';
import { useStepSelectionOnMount } from './hooks/useStepSelectionOnMount';
import { useSessionTimeOutRender } from './hooks/useSessionTimeOutRender';
import { useStepsViewStyling } from './hooks/useStepsViewStyling';

const StepsViewComponent = ({ flags, userProfile, immStepsState, stepsActions, closeIban }) => {
    const { iban, identityStatus, investmentType } = userProfile;
    const videoSeflieCaptureFlag = flags.get(VIDEOSELFIE_CAPTURE);

    useStepSelectionOnMount({ userProfile, immStepsState, stepsActions });
    const { renderSessionTimeout } = useSessionTimeOutRender();
    const { containerClassName } = useStepsViewStyling({
        identityStatus,
        videoSeflieCaptureFlag,
    });

    if (typeof iban === 'undefined') return null;

    const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(investmentType);

    return (
        <div className={containerClassName}>
            <Header showContinueProcess={false} />
            {renderSessionTimeout()}
            <ConditionalToggling condition={!userInvestmentType[CREDIT_CARD]}>
                <Iban userProfile={userProfile} close={closeIban} />
            </ConditionalToggling>
            <div className="prospects-step-content">
                <StepsContent />
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    immStepsState: state.steps,
    userProfile: state.userProfile,
});
const mapDispatchToProps = dispatch => ({
    closeIban: () => dispatch(ibanActions.toggleShowIban.call(undefined, false)),
    logActions: bindActionCreators(logActions, dispatch),
    stepsActions: bindActionCreators(stepsActions, dispatch),
});

export const StepsView = withRouter(
    withFeatureToggling(connect(mapStateToProps, mapDispatchToProps)(StepsViewComponent))
);
